'use strict';
const {mapGetters, mapState} = require('vuex');

module.exports = {
    computed: {
        ...mapGetters('delivery', [
            'selectedDeliveryMethod',
            'isPickupPersonValid',
            'isPostnummerValid',
            'isPickPostValid'
        ]),
        ...mapGetters('addressBook', ['hasSavedAddress']),
        ...mapGetters('details', [
            'isFieldValid',
            'firstInvalidShippingElementId',
            'firstInvalidBillingElementId',
            'firstInvalidCompanyElementId',
            'getPlaceholderPhoneNumber'
        ]),
        ...mapState('delivery', {
            deliveryResources: 'resources',
            deliveryPostalCode: 'postalCode'
        }),
        ...mapState('details', {
            detailsEditMode: 'editMode',
            detailsResources: 'resources',
            isB2BSite: 'isb2b',
            loggedInCustomer: 'loggedInCustomer'
        }),
        ...mapState('delivery', ['deliverySummary', 'exclusionResults', 'isMember']),
        ...mapState('payments', [
            'environment',
            'clientKey',
            'locale',
            'countryCode',
            'readMode',
            'preselectedPaymentMethod',
            'selectedPaymentMethod',
            'payingFullAmountWithGiftcard',
            'setPaymentMethodError',
            'merchantIdentifier'
        ]),
        ...mapGetters('payments', ['giftcardOptionsField']),
        ...mapState('payments', {paymentsResources: 'resources'}),
        ...mapState('orderSummary', ['orderTotalsPriceForAdyen']),
        ...mapGetters('privacyConsent', {isPrivacyConsentValid: 'isValid'}),
        bankOptionsField() {
            return this.$store.getters['payments/bankOptionsField'](this.selectedPaymentMethod.type);
        }
    },
    methods: {
        validatePostal() {
            const isPostalValid = this.checkIfPostalIsValid();
            if (!isPostalValid) {
                this.$store.commit('delivery/setEditMode', true);
                this.$store.commit('details/addValidationError', {
                    formId: 'shippingAddress',
                    fieldId: 'postalCode',
                    error: this.detailsResources.postalDetailsError
                });
                this.$store.commit('delivery/addPostalCodeError', this.detailsResources.postalDeliveryError);
            }
            return isPostalValid;
        },
        validateDeliveryPostal() {
            const isPostalChanged = this.hasDeliveryPostalChanged();
            if (isPostalChanged) {
                this.$store.commit('delivery/setEditMode', true);
                this.$store.commit('details/addValidationError', {
                    formId: 'shippingAddress',
                    fieldId: 'postalCode',
                    error: this.deliveryResources.deliveryBlockSaveValidationWarning
                });
                this.$store.commit(
                    'delivery/addPostalCodeError',
                    this.deliveryResources.deliveryBlockSaveValidationWarning
                );
            }
            return isPostalChanged;
        },
        checkIfPostalIsValid() {
            return (
                !this.$store.getters['details/shippingPostalCodeValue'] ||
                this.$store.getters['details/shippingPostalCodeValue'] ===
                    this.$store.getters['delivery/postalCodeValue']
            );
        },
        hasDeliveryPostalChanged() {
            return this.deliveryPostalCode !== this.$store.getters['delivery/postalCodeValue'];
        },
        validateDetailsBlock() {
            if (!this.hasSavedAddress) {
                const guestResult = this.validateDetailsNoSavedAddressFlow();
                if (this.countryCode === 'US') {
                    const res = this.triggerDetailsEditModeError(guestResult);
                    if (res && res !== null) {
                        return res;
                    }
                }
                return guestResult;
            }

            const result = this.validateDetailsSavedAddressFlow();

            const res = this.triggerDetailsEditModeError(result);
            if (res && res !== null) {
                return res;
            }

            return result;
        },
        triggerDetailsEditModeError(result) {
            if (this.detailsEditMode) {
                this.$store.commit('details/setShowEditModeError', true);
            }

            if (this.detailsEditMode && result.isValid) {
                return {
                    isValid: false,
                    badElementId: 'detailsSection'
                };
            }
        },
        checkIfDetailsBlockIsValid() {
            if (this.hasSavedAddress) {
                return this.detailsEditMode
                    ? {
                          isValid: false,
                          badElementId: 'detailsSection'
                      }
                    : this.checkIfDetailsSavedAddressFlowIsValid();
            }

            if (this.selectedDeliveryMethod.id === 'homeDelivery') {
                const isPostalValid = this.checkIfPostalIsValid();
                if (!isPostalValid) {
                    return {
                        isValid: false,
                        badElementId: 'shippingAddress_postalCode'
                    };
                }
            }

            return this.checkIfDetailsNoSavedAddressFlowIsValid();
        },
        validateDetailsSavedAddressFlow() {
            this.$store.commit('details/validateForm', 'shippingAddress');
            this.$store.commit('details/validateForm', 'billingAddress');
            const deliveryResult = this.validateDeliveryBlock();
            if (!deliveryResult.isValid) {
                return deliveryResult;
            }
            return this.checkIfDetailsSavedAddressFlowIsValid();
        },
        checkIfDetailsSavedAddressFlowIsValid() {
            const isPhoneValid = this.isFieldValid('shippingAddress', 'phone');
            const isVatValid =
                this.isFieldValid('billingAddress', 'btwVatNumber') && this.isFieldValid('billingAddress', 'nifNumber');
            const badElementId = !isPhoneValid
                ? 'shippingAddress_phone'
                : !isVatValid
                ? 'billingAddress_btwVatNumber'
                : '';

            return {
                isValid: isPhoneValid && isVatValid,
                badElementId
            };
        },
        validateDetailsNoSavedAddressFlow() {
            this.$store.commit('details/validateForm', 'billingAddress');
            this.$store.commit('details/validateForm', 'shippingAddress');
            if (this.isB2BSite) {
                this.$store.commit('details/validateForm', 'companydetails');
            }
            const deliveryResult = this.validateDeliveryBlock();
            if (!deliveryResult.isValid) {
                return deliveryResult;
            }

            if (this.selectedDeliveryMethod.id === 'homeDelivery') {
                const isPostalValid = this.validatePostal();
                const isDeliveryPostalChanged = this.validateDeliveryPostal();
                if (isDeliveryPostalChanged) {
                    return {
                        isValid: false,
                        badElementId: 'deliverySection',
                        errorMessage: this.deliveryResources.deliveryBlockSaveValidationWarning
                    };
                } else if (!isPostalValid) {
                    return {
                        isValid: false,
                        badElementId: 'deliverySection',
                        errorMessage: this.deliveryResources.postalTopBanerError
                    };
                }
            }

            return this.checkIfDetailsNoSavedAddressFlowIsValid();
        },
        checkIfDetailsNoSavedAddressFlowIsValid() {
            const isBillingValid = this.$store.getters['details/isBillingValid'];
            const badElementId = isBillingValid ? '' : this.firstInvalidBillingElementId;
            if (this.selectedDeliveryMethod.id !== 'homeDelivery') {
                const isPhoneValid = this.isFieldValid('shippingAddress', 'phone');
                return {
                    isValid: isBillingValid && isPhoneValid,
                    badElementId: isPhoneValid ? badElementId : 'shippingAddress_phone'
                };
            }

            const isShippingValid = this.$store.getters['details/isShippingValid'];
            if (!isShippingValid) {
                return {
                    isValid: false,
                    badElementId: this.firstInvalidShippingElementId
                };
            }

            const isCompanyDetailsValid = this.$store.getters['details/isCompanyDetailsValid'];
            if (!isCompanyDetailsValid && this.isB2BSite) {
                return {
                    isValid: false,
                    badElementId: this.firstInvalidCompanyElementId
                };
            }

            return {
                isValid: isShippingValid && isBillingValid,
                badElementId
            };
        },
        validateDeliveryBlock() {
            this.$store.commit('delivery/validatePickupPerson');
            this.$store.commit('delivery/validatePostnummer');
            this.$store.commit('delivery/validatePickPost');
            if (
                (this.hasSavedAddress ||
                    (this.deliverySummary.hasLastOrder && this.deliverySummary.hasPostalCodePreApplied)) &&
                this.deliverySummary.editMode
            ) {
                this.$store.commit('delivery/setShowEditModeError', true);
            }

            return this.checkIfDeliveryBlockIsValid();
        },
        checkIfDeliveryBlockIsValid() {
            const isEditMode =
                !(
                    this.hasSavedAddress ||
                    (this.deliverySummary.hasLastOrder && this.deliverySummary.hasPostalCodePreApplied)
                ) || !this.deliverySummary.editMode;

            return {
                isValid:
                    this.selectedDeliveryMethod &&
                    this.selectedDeliveryMethod.selected &&
                    isEditMode &&
                    this.isPickupPersonValid &&
                    this.isPostnummerValid &&
                    this.isPickPostValid,
                badElementId: 'deliverySection'
            };
        },
        checkIfAllBlocksAreValid() {
            return this.checkIfDetailsBlockIsValid().isValid && this.checkIfDeliveryBlockIsValid().isValid;
        },
        submitDetails() {
            if (this.hasSavedAddress) {
                return this.$store.dispatch('details/submitMemberDetails');
            }

            return this.$store.dispatch('details/postForms');
        },
        scrollIntoSection(elementId) {
            const element = document.getElementById(elementId);
            if (element) {
                element.scrollIntoView({
                    behavior: 'smooth'
                });
            }
        },
        validatePrivacyConsent() {
            this.$store.commit('privacyConsent/validate');
            if (this.isPrivacyConsentValid) {
                return {
                    isValid: true
                };
            }

            return {
                isValid: false,
                badElementId: 'privacyConsent'
            };
        },
        validatePaymentsBlock() {
            const isPaymentBlockValid = {
                isValid: false,
                badElementId: 'paymentsSection'
            };

            if (this.giftcardOptionsField && this.giftcardOptionsField.state.value) {
                return isPaymentBlockValid;
            }

            if (!this.isBankOptionsFieldValid()) {
                return isPaymentBlockValid;
            }

            if (
                !this.readMode &&
                this.preselectedPaymentMethod &&
                (['bcmc', 'scheme'].indexOf(this.selectedPaymentMethod.type) < 0 || this.payingFullAmountWithGiftcard)
            ) {
                this.$store.commit('payments/setShowEditModeError', true);
                return isPaymentBlockValid;
            }

            if (this.preselectedPaymentMethod) {
                this.$store.commit('payments/setShowEditModeError', false);
            }

            if (this.exclusionResults && this.exclusionResults.errorMessage) {
                this.$store.commit('error/setErrorMessage', this.exclusionResults.errorMessage, {root: true});
                return {
                    isValid: false,
                    badElementId: 'deliverySection'
                };
            }

            const validationResult = this.validateDetailsBlock();
            if (!validationResult.isValid) {
                this.$store.commit('details/setEditMode', true);
                this.$store.commit(
                    'error/setErrorMessage',
                    validationResult.errorMessage || this.paymentsResources.errors.missingFields,
                    {root: true}
                );
                this.$store.commit('payments/setPaymentMethodError', this.paymentsResources.errors.requiredFields);

                return {
                    isValid: false,
                    badElementId: 'detailsSection'
                };
            }

            this.$store.commit('error/setErrorMessage', null, {root: true});
            this.$store.commit('payments/setPaymentMethodError', null);

            return this.validatePrivacyConsent();
        },
        paymentMethodConfiguration() {
            return {
                clientKey: this.clientKey,
                environment: this.environment,
                locale: this.locale,
                priceAmount: this.orderTotalsPriceForAdyen.remainingAmountInSmallestUnit,
                priceCurrency: this.orderTotalsPriceForAdyen.currencyCode,
                countryCode: this.countryCode,
                merchantId: this.merchantIdentifier
            };
        },
        amazonPaymentDetails() {
            return {
                countryCode: this.countryCode,
                name:
                    this.deliverySummary.deliveryAddress.firstName +
                    ' ' +
                    this.deliverySummary.deliveryAddress.lastName,
                adressLine1: this.deliverySummary.deliveryAddress.address1,
                city: this.deliverySummary.deliveryAddress.city,
                postalCode: this.deliverySummary.deliveryAddress.postalCode,
                phoneNumber: this.phoneNumber || this.getPlaceholderPhoneNumber
            };
        },
        isBankOptionsFieldValid() {
            if (!this.bankOptionsField) {
                return true;
            }
            this.$store.commit('payments/validateForm', this.selectedPaymentMethod.type);
            return !!this.bankOptionsField.state.selectedOption;
        }
    }
};
